var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",class:{ fixed: _vm.fixed },on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":"https://www.iage-france.com/wp-content/uploads/2022/09/IAGE_MAQUETTE_4V_V1-1.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }